import { Button } from '@/components/primitives/button'
import { LanguageSegmentedControl } from '@/features/auth/components/language-segmented-control'
import { MobileAuthBrandHeader } from '@/features/auth/mobile/mobile-auth-brand-header'
import { MobileAuthLayout } from '@/features/auth/mobile/mobile-auth-layout'
import { useOAuthAuthorizationResumePage } from '@/features/auth/oauth/use-oauth-authorization-resume-page'
import { setAppLanguage } from '@/i18n/i18n'
import { clearPortalSession } from '@/lib/auth/portal-session'

export function MobileOAuthAuthorizationResumePage() {
  const { failed, language, t } = useOAuthAuthorizationResumePage()
  return (
    <MobileAuthLayout
      actions={
        <LanguageSegmentedControl
          language={language}
          onLanguageChange={(nextLanguage) => void setAppLanguage(nextLanguage)}
          t={t}
        />
      }
    >
      <div className="grid min-h-[300px] content-center gap-6">
        <MobileAuthBrandHeader title={t('user.title')} />
        {failed ? (
          <div className="grid gap-5">
            <div
              className="rounded-lg bg-red-50 px-4 py-3 text-sm leading-6 text-[var(--color-danger)]"
              role="alert"
            >
              <p className="font-semibold">{t('oauthAuthorization.errorTitle')}</p>
              <p className="mt-1">{t('oauthAuthorization.errorDescription')}</p>
            </div>
            <Button
              className="h-[46px] rounded-lg text-base font-bold"
              onClick={() => {
                clearPortalSession('user')
                window.location.assign('/login?resume=oauth_authorization')
              }}
              type="button"
            >
              {t('oauthAuthorization.backToLogin')}
            </Button>
          </div>
        ) : (
          <div className="grid justify-items-center gap-[14px] text-center">
            <div className="size-[26px] animate-spin rounded-full border-2 border-[rgba(25,91,255,0.16)] border-t-[var(--color-primary)]" />
            <p className="text-sm leading-5 text-[var(--color-text)]">
              {t('oauthAuthorization.processing')}
            </p>
            <Button
              className="h-11 px-3 text-[13px] text-[var(--color-primary)]"
              onClick={() => window.location.assign('/login')}
              type="button"
              variant="ghost"
            >
              {t('oauthAuthorization.backToLogin')}
            </Button>
          </div>
        )}
      </div>
    </MobileAuthLayout>
  )
}
